import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import aboutUs from '../../assets/aboutUs.png';
import { fetchBioPage } from '../../api/BioPageApi';
import { BioPageBody } from './components/BioPageBody';
import { normalizeBioPageContent } from './types';
import styles from './About.module.scss';
const EMPTY_CONTENT = { introContent: '', categories: [] };
const About = () => {
    const [content, setContent] = useState(EMPTY_CONTENT);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        let isMounted = true;
        fetchBioPage()
            .then((response) => {
            if (!isMounted)
                return;
            setContent(normalizeBioPageContent(response.body));
        })
            .catch((error) => {
            console.error('Error loading bio page:', error);
        })
            .finally(() => {
            if (isMounted)
                setLoading(false);
        });
        return () => {
            isMounted = false;
        };
    }, []);
    return (_jsxs(_Fragment, { children: [_jsxs("section", { className: styles.hero, children: [_jsx("img", { src: aboutUs, alt: "Landing", className: styles.heroImage }), _jsx("div", { className: styles.heroContent, children: _jsx("h1", { children: "Science Driven Solutions for Healthier Animals" }) })] }), loading ? (_jsx("div", { className: styles.loading, children: "Loading..." })) : (_jsx(BioPageBody, { content: content }))] }));
};
export default About;
